import { render, staticRenderFns } from "./i-modal-control-buttons.vue?vue&type=template&id=5291b212&scoped=true&"
import script from "./i-modal-control-buttons.vue?vue&type=script&lang=js&"
export * from "./i-modal-control-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291b212",
  null
  
)

export default component.exports